/**
 * @param {object} req
 * @returns {string|undefined}
 */
function getUserIp (req) {
  let userIp = 'localhost'

  if (req?.headers?.['x-forwarded-for'] || req?.connection?.remoteAddress) {
    // x-forwarded-for arrives as simple string XXX.XXX.XXX.XXX in test
    // x-forwarded-for arrives in this format in production XXX.XXX.XXX.XXX, XXX.XXX.XXX.XXX (CSV)
    // with the following order: client, proxy1, proxy2, etc.
    userIp = req?.headers?.['x-forwarded-for'] || req?.connection?.remoteAddress
    userIp = userIp?.split(', ')
    userIp = userIp?.[0]

    const testIp = userIp?.substring(0, userIp?.lastIndexOf('.'))
    if (testIp) userIp = `${testIp}.0`
  }

  return userIp
}

module.exports = { getUserIp }
